import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const BOAT = {
  nickname: 'PRODUCTS.BOAT.nickname',
  properties: [
    { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'boatBuiltYear', key: 'BUILD_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_BOAT.4', value: '4000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_BOAT.8', value: '8000' }
        ]
      }
    },
    { name: 'boatMaxSpeed', key: 'BOAT_MAX_SPEED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.10', value: '10' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.15', value: '15' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.20', value: '20' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.25', value: '25' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.30', value: '30' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.35', value: '35' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.40', value: '40' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.45', value: '45' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.50', value: '50' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.51', value: '51' },
        ]
      }
    },
    { name: 'boatType', key: 'BOAT_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.INBOARD_ENGINE', value: 'INBOARD_ENGINE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.OUTBOARD_ENGINE', value: 'OUTBOARD_ENGINE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.SAILBOAT', value: 'SAILBOAT' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.ROWING_BOAT', value: 'ROWING_BOAT' },
          // { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.SAILING_BOARD', value: 'SAILING_BOARD' },
          // { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.CANOE', value: 'CANOE' },
          // { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.KAYAK', value: 'KAYAK' }
        ]
      }
    },
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      validator: ['', [
        Validators.required
      ]],
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO_PLUS', value: 'KASKO_PLUS' }
        ]
      }
    },
    { name: 'boatLength', key: 'BOAT_LENGTH', group: 'OBJECT_INFO' },
    { name: 'boatEngineHP', key: 'BOAT_ENGINE_HP', group: 'OBJECT_INFO' },
    { name: 'boatMotorMake', key: 'BOAT_MOTOR_MAKE', group: 'OBJECT_INFO' }
  ],
  icon:'boat'
};
